module.exports = __webpack_public_path__ + "img/01-main.7d8634f1.svg";